export const addresses = {
  messagePnounsToken: "0xF277D0d606E8749CC6bf102871fED902F843Fdb0",
};
